<!-- FIRST LINE -->
<div class="spacing--margin-top flex--row flex--nowrap">
  <div class="flex--column">
    <span class="text--small text--bold label">
      {{ 'feedAdviceType.label' | translate }}
    </span>
  </div>
  <div class="flex--column spacing--padding-right spacing--padding-half-vertical">
    <span class="text--small text-field">{{
      'select-feed-advice-type.' + feedAdviceType | translate
    }}</span>
  </div>
  <ng-container *ngIf="hasValidation">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.phaseTransition.label' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <mat-radio-group (change)="changeProperties()" [(ngModel)]="displayedPhaseTransition">
        <mat-radio-button
          data-test="feed-advice-properties__phaseTransition-gradual-radiobutton"
          class="text--small"
          color="primary"
          [value]="'Gradual'"
        >
          {{ 'feed-advice-properties.phaseTransition.gradual' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="feed-advice-properties__phaseTransition-abrupt-radiobutton"
          class="text--small"
          color="primary"
          [value]="'Abrupt'"
        >
          {{ 'feed-advice-properties.phaseTransition.abrupt' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </ng-container>
  <ng-container *ngIf="!isRearingGilt() && !isFilter">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-terminalboar.label' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        class="formfield-outline"
        (selectionChange)="changeProperties()"
        [(ngModel)]="terminalBoar"
        data-test="feed-advice-properties__terminal-boar"
      >
        <mat-option value="">
          {{ 'feed-advice-terminalboar.no-selection' | translate }}
        </mat-option>
        <mat-option *ngFor="let boar of terminalBoars" [value]="boar">{{ boar }}</mat-option>
      </mat-select>
    </div>
  </ng-container>
  <ng-container *ngIf="(isWeanedPiglets() || isRearingGilt()) && !isFilter">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.genetic-line' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        class="formfield-outline"
        [ngModel]="geneticLine"
        placeholder="{{ 'feed-advice-properties.genetic-line-default' | translate }}"
        (selectionChange)="selectGeneticLine($event)"
        data-test="feed-advice-properties__genetic-line"
      >
        <mat-option [value]="null">
          {{ 'feed-advice-properties.genetic-line-default' | translate }}
        </mat-option>
        <mat-option *ngFor="let line of geneticLines" [value]="line">{{
          line | translate
        }}</mat-option>
      </mat-select>
    </div>
  </ng-container>
</div>
<!-- SECOND LINE -->
<div class="spacing--margin-top flex--row text--small">
  <div class="flex--column">
    <span class="text--small text--bold label">
      {{ 'gender.label' | translate }}
    </span>
  </div>
  <div class="flex--column spacing--padding-right">
    <agr-chips-filter
      [multiple]="true"
      [items]="displayedGenders"
      (change)="changeProperties($event)"
    >
    </agr-chips-filter>
    <div *ngIf="hasValidation && genderValidationError" class="validation-error">
      {{ 'feed-advice-detail.validation-error.description.gender' | translate }}
    </div>
  </div>
  <ng-container *ngIf="isFatteningOrRearing()">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.feedintake.label' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <mat-radio-group [(ngModel)]="feedintake" (change)="changeProperties()">
        <mat-radio-button
          data-test="feed-advice-properties__feedintake-radiobutton"
          color="primary"
          [value]="'Low'"
        >
          {{ 'feed-advice-properties.feedintake.low' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="feed-advice-properties__feedintake-radiobutton"
          color="primary"
          [value]="'Average'"
        >
          {{ 'feed-advice-properties.feedintake.average' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="feed-advice-properties__feedintake-radiobutton"
          class="text--small"
          color="primary"
          [value]="'High'"
        >
          {{ 'feed-advice-properties.feedintake.high' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </ng-container>
  <ng-container *ngIf="isWeanedPiglets()" [formGroup]="formGroup">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.weaningWeight.label' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <input
        (change)="changeProperties()"
        matInput
        class="formfield-outline width-80"
        [min]="1"
        [step]="0.1"
        [value]="weaningWeight"
        data-test="feed-advice-properties__weaning-weight"
        formControlName="weaningWeight"
        type="number"
        [class.error-border]="
          hasValidation &&
          weaningAgeFormControl.touched &&
          (weaningWeightFormControl.errors ||
            weaningWeightFormControl.errors?.max ||
            weaningWeightFormControl.errors?.min)
        "
      />
      <span
        class="validation-error"
        *ngIf="
          hasValidation &&
          weaningAgeFormControl.touched &&
          (weaningWeightFormControl.errors ||
            weaningWeightFormControl.errors?.max ||
            weaningWeightFormControl.errors?.min)
        "
      >
        {{ 'feed-advice-properties.weaningWeight.error' | translate }}
      </span>
    </div>

    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.weaningAge.label' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <input
        (change)="changeProperties()"
        matInput
        class="formfield-outline width-80"
        [min]="1"
        [step]="1"
        [value]="weaningAge"
        data-test="feed-advice-properties__weaning-age"
        formControlName="weaningAge"
        type="number"
        [class.error-border]="
          hasValidation &&
          weaningAgeFormControl.touched &&
          (weaningAgeFormControl.errors ||
            weaningAgeFormControl.errors?.max ||
            weaningAgeFormControl.errors?.min)
        "
      />
      <span
        class="validation-error"
        *ngIf="
          hasValidation &&
          weaningAgeFormControl.touched &&
          (weaningAgeFormControl.errors ||
            weaningAgeFormControl.errors?.max ||
            weaningAgeFormControl.errors?.min)
        "
      >
        {{ 'feed-advice-properties.weaningAge.error' | translate }}
      </span>
    </div>
  </ng-container>
</div>
<div class="flex--row flex--nowrap">
  <div class="flex--column">
    <span class="text--small text--bold label">
      {{ 'feed-advice-properties.phases' | translate }}
    </span>
  </div>
  <div class="flex--column">
    <mat-radio-group [(ngModel)]="phases" (change)="changeProperties()">
      <mat-radio-button
        *ngIf="isWeanedPiglets()"
        data-test="feed-advice-properties__phases-radiobutton"
        color="primary"
        [value]="1"
      >
        1
      </mat-radio-button>
      <mat-radio-button
        data-test="feed-advice-properties__phases-radiobutton"
        color="primary"
        [value]="2"
      >
        2
      </mat-radio-button>
      <mat-radio-button
        data-test="feed-advice-properties__phases-radiobutton"
        color="primary"
        [value]="3"
      >
        3
      </mat-radio-button>
      <mat-radio-button
        data-test="feed-advice-properties__phases-radiobutton"
        color="primary"
        [value]="4"
      >
        4
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>

<div *ngIf="inputSystem" class="flex--row flex--nowrap input-mode-container">
  <div class="flex--column">
    <span class="text--small text--bold label">
      {{ 'feed-advice-properties.input-system.label' | translate }}
    </span>
  </div>
  <div class="flex--column">
    <mat-radio-group (change)="changeProperties()" [(ngModel)]="inputSystem">
      <mat-radio-button
        data-test="feed-advice-properties_input-system-energy-radiobutton"
        class="text--small"
        color="primary"
        [value]="'EnergyDay'"
      >
        {{ 'feed-advice-properties.input-system.energy' | translate }}
      </mat-radio-button>
      <mat-radio-button
        data-test="feed-advice-properties_input-system-feed-radiobutton"
        class="text--small"
        color="primary"
        [value]="'KgDay'"
      >
        {{ 'feed-advice-properties.input-system.feed' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="flex--column show-lysine-switch">
    <mat-slide-toggle
      ngDefaultControl
      color="primary"
      [hideIcon]="true"
      [(ngModel)]="showLysine"
      (change)="changeShowLysineSetting()"
      data-test="feed-advice-properties_show-lysine-switch"
    >
      <span class="text--small">{{ 'feed-advice-properties.show-lysine-switch' | translate }}</span>
    </mat-slide-toggle>
  </div>
  <div class="flex--column show-energy-switch" *ngIf="isRearingGilt()">
    <mat-slide-toggle
      ngDefaultControl
      color="primary"
      [hideIcon]="true"
      [(ngModel)]="showEnergy"
      (change)="changeShowEnergySetting()"
      data-test="feed-advice-properties_show-energy-switch"
    >
      <span class="text--small">{{ 'feed-advice-properties.show-energy-switch' | translate }}</span>
    </mat-slide-toggle>
  </div>
  <div class="flex--column show-dosator-switch" *ngIf="isRearingGilt()">
    <mat-slide-toggle
      ngDefaultControl
      color="primary"
      [hideIcon]="true"
      [(ngModel)]="showDosator"
      (change)="changeShowDosatorSetting()"
      data-test="feed-advice-properties_show-dosator-switch"
    >
      <span class="text--small">{{
        'feed-advice-properties.show-dosator-switch' | translate
      }}</span>
    </mat-slide-toggle>
  </div>
</div>

<div *ngIf="isRearingGilt()" class="flex--row flex--nowrap">
  <div class="flex--column">
    <span class="text--small text--bold label">
      {{ 'feed-advice-properties.feeding-type.label' | translate }}
    </span>
  </div>
  <div class="flex--column">
    <mat-radio-group (change)="changeProperties()" [(ngModel)]="feedingType">
      <mat-radio-button class="text--small" color="primary" [value]="FeedAdviceTypeOptions.CDI">
        {{ 'feed-advice-properties.feeding-type.cdi' | translate }}
      </mat-radio-button>
      <mat-radio-button class="text--small" color="primary" [value]="FeedAdviceTypeOptions.MANUAL">
        {{ 'feed-advice-properties.feeding-type.manual' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>

<div class="spacing--margin-top flex--row flex--nowrap">
  <ng-container *ngIf="isRearingGilt()" [formGroup]="formGroupRearingAge">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.rearingAge.label' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <input
        (change)="changeProperties()"
        matInput
        class="formfield-outline width-80"
        [min]="1"
        [step]="1"
        [value]="rearingAge"
        data-test="feed-advice-properties__rearing-age"
        formControlName="rearingAge"
        type="number"
        [class.error-border]="
          hasValidation &&
          rearingAgeFormControl.touched &&
          (rearingAgeFormControl.errors ||
            rearingAgeFormControl.errors?.max ||
            rearingAgeFormControl.errors?.min)
        "
      />
      <span
        class="validation-error"
        *ngIf="
          hasValidation &&
          rearingAgeFormControl.touched &&
          (rearingAgeFormControl.errors ||
            rearingAgeFormControl.errors?.max ||
            rearingAgeFormControl.errors?.min)
        "
      >
        {{ 'feed-advice-properties.rearingAge.error' | translate }}
      </span>
    </div>
  </ng-container>
</div>

<div class="spacing--margin-top flex--row flex--nowrap">
  <ng-container *ngIf="hasValidation && shouldCalculateDosatorColumns()">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'settings.dosator-settings' | translate }}:
      </span>
    </div>

    <div class="flex--column spacing--padding-right">
      <mat-select
        #dosatorSettingSelector
        [hideSingleSelectionIndicator]="true"
        class="formfield-outline"
        data-test="feed-advice-properties__dosator-settings"
        (ngModelChange)="selectDosatorSetting($event.id)"
        [(ngModel)]="selectedDosatorSetting"
      >
        <mat-option
          *ngFor="let dosatorSetting of dosatorSettings$ | async"
          [value]="dosatorSetting"
        >
          {{ dosatorSetting.name }}
        </mat-option>
      </mat-select>
    </div>
  </ng-container>
</div>
